import { render, staticRenderFns } from "./FooterComp.vue?vue&type=template&id=15626b96&scoped=true&"
import script from "./FooterComp.vue?vue&type=script&lang=js&"
export * from "./FooterComp.vue?vue&type=script&lang=js&"
import style0 from "./FooterComp.vue?vue&type=style&index=0&id=15626b96&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15626b96",
  null
  
)

export default component.exports